import React, { Component } from 'react';
import {getSearch} from '../components/Factory' 
import Search from '../components/Search'; 
import Flexbox from '../components/misc/Flexbox'; 

class SearchContainer extends Component {
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}
	render() {		   
		   const { page,result,query } = this.props.resolves;
		   const { label_keyword } = this.props.resolves.staticData;
		   return (
				<div className="container-fluid lg-side-padding search-results">
					<div className="row">
						<div className="col-md-12">
                            <Flexbox left={page.title_left} right={page.title_right} />
                            <div className="content-container">                                
                                <p className="lg-txt search-query">{label_keyword}: „{decodeURIComponent(query)}“</p>
                                <Search result = {result} /> 
                            </div>
						</div> 
					</div>
				</div>
			)
	   
	}
}
export function search(query){
	let queryitem = query;
	return fetch(getSearch({ 
						query:query,
					}))
				  .then(res => res.json())
				  .then(res => {
					document.title = "Search "+queryitem+" - Taxispalais";
					return res;		
				  })
}
export default SearchContainer;


// WEBPACK FOOTER //
// ./src/containers/SearchContainer.js